module.exports = __webpack_public_path__ + "static/paymentThumb2-89aa9642e6b34842653e2e861103c4ba.png";